import React from 'react';
import PageLayout from '../components/PageLayout';

const PrivacyPolicyPage = () => {
  return (
    <PageLayout title="Privacy Policy">
      <p>Last Updated: March 11, 2025</p>

      <h3>Introduction</h3>
      <p>
        Curators' Studio ("we," "our," or "us") is committed to protecting your
        privacy. This Privacy Policy explains how we collect, use, disclose, and
        safeguard your information when you use our website and services. Please
        read this privacy policy carefully. If you do not agree with the terms
        of this privacy policy, please do not access our website or use our
        services.
      </p>

      <h3>Information We Collect</h3>
      <p>We collect information that you voluntarily provide to us when you:</p>
      <ul>
        <li>Register for our flower subscription service</li>
        <li>Place an order</li>
        <li>Sign up for our newsletter</li>
        <li>Contact us</li>
        <li>Participate in our surveys or promotions</li>
      </ul>
      <p>The personal information we may collect includes:</p>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Billing and delivery address</li>
        <li>Payment information</li>
        <li>Communication preferences</li>
      </ul>

      <h3>How We Use Your Information</h3>
      <p>
        We may use the information we collect for various purposes, including:
      </p>
      <ul>
        <li>Processing and fulfilling your subscription orders</li>
        <li>Managing your account</li>
        <li>Providing customer support</li>
        <li>Sending transactional emails and order confirmations</li>
        <li>Sending marketing communications if you have opted in</li>
        <li>Improving our website and services</li>
        <li>Conducting research and analysis</li>
        <li>Preventing fraudulent activities</li>
      </ul>

      <h3>Disclosure of Your Information</h3>
      <p>We may share your information with:</p>
      <ul>
        <li>Service providers who help us operate our business</li>
        <li>Payment processors to complete transactions</li>
        <li>Delivery partners to fulfill your orders</li>
        <li>Legal authorities when required by law</li>
      </ul>
      <p>
        We do not sell, rent, or trade your personal information to third
        parties for marketing purposes.
      </p>

      <h3>Your Rights</h3>
      <p>
        You have certain rights regarding your personal information, including:
      </p>
      <ul>
        <li>The right to access the personal information we hold about you</li>
        <li>The right to request correction of inaccurate information</li>
        <li>The right to request deletion of your information</li>
        <li>The right to opt out of marketing communications</li>
      </ul>

      <h3>Data Security</h3>
      <p>
        We implement appropriate security measures to protect your personal
        information from unauthorized access, alteration, disclosure, or
        destruction. However, no data transmission over the Internet or
        electronic storage is completely secure, so we cannot guarantee absolute
        security.
      </p>

      <h3>Updates to This Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. The updated version
        will be indicated by an updated "Last Updated" date. We encourage you to
        review this Privacy Policy periodically to stay informed about how we
        are protecting your information.
      </p>

      <h3>Contact Us</h3>
      <p>
        If you have any questions about this Privacy Policy, please contact us
        at:
      </p>
      <p>
        Email: privacy@curators.studio
        <br />
        Phone: +91 9008789490
        <br />
        Address: Gurugram, Haryana, India
      </p>
    </PageLayout>
  );
};

export default PrivacyPolicyPage;
